import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import "./Footer.scss";

import ZYXMedia from "./../Images/zyx-media.svg";

const handleContactClick = () => {
    window.dispatchEvent(new Event("scrollToForm"));
};

const menuItems1 = [
    { name: "About Us", to: "/About-Us", },
    { name: "Our Services", to: "/Services", },
    { name: "Contact Us", },
    { name: "Blog Posts", },
    { name: "Case Studies", },
]

const menuItems2 = [
    { name: "Instagram", to: "https://www.instagram.com/media.zyx/" },
    { name: "LinkedIn", to: "https://www.linkedin.com/company/zyxmedia/" },
    { name: "Facebook", to: "https://www.facebook.com/profile.php?id=61566323691829" },
    { name: "YouTube", to: "https://www.youtube.com/@ZYX_Media" },
    { name: "WhatsApp", to: "https://whatsapp.com/channel/0029VanuksG2phHJ4gbZya26" },
]

const copyItems = [
    { name: "Privacy Policy", },
    { name: "Terms of Use", },
    { name: "Cookie Preferences", },
]

const socialItems = [
    { class: "instagram", to: "https://www.instagram.com/media.zyx/" },
    { class: "linkedin", to: "https://www.linkedin.com/company/zyxmedia/" },
    { class: "facebook", to: "https://www.facebook.com/profile.php?id=61566323691829" },
    { class: "youtube", to: "https://www.youtube.com/@ZYX_Media" },
    { class: "whatsapp", to: "https://whatsapp.com/channel/0029VanuksG2phHJ4gbZya26" },
]

export default function Footer() {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY >= 500) {
                setIsActive(true);
            } else {
                setIsActive(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };
    return (
        <footer>
            <div id='Footer' className='footer bg-pattern' data-aos="fade-up" data-aos-once='true'>
                <div className='container-fluid float-none'>
                    <button className={`b-top up-arrow ${isActive ? 'active' : ''}`} onClick={scrollToTop}></button>
                    <div className='foot-cont sectin'>
                        <div className='row'>
                            <div className='col-xl-4 col-18 mb-0'>
                                <div className='logo'><Link to="/"><img src={ZYXMedia} alt='ZYX Media' title='ZYX Media' width='500' height='91' /></Link></div>
                                <div className={`foot-expand down-arrow ${isExpanded ? 'active' : ''}`} onClick={toggleExpand}></div>
                            </div>
                            <div className={`col-xl-4 col-md-7 col-18 foot-list mb-0 ${isExpanded ? 'show' : ''}`}>
                                <h6 className='f-16 fw-600 txt-white'>Get in Touch</h6>
                                <ul>
                                    <li className='locate foot-icon txt-white-60'>No. 5, Chakrapani Street, Guindy, Chennai, Tamil&nbsp;Nadu, <span className='d-in-blk txt-white-60'>India&nbsp;-&nbsp;600&nbsp;032</span>.</li>
                                    <li><Link className='mail foot-icon txt-white-60' to={`mailto:admin@zyxmedia.in`}>admin@zyxmedia.in</Link></li>
                                    <li><Link className='phone foot-icon txt-white-60' to={`tel:9597460809`}>+91 95974 60809</Link></li>
                                </ul>
                            </div>
                            <div className={`col-xl-2 col-md-4 col-9 foot-list2 mb-lg-0 ${isExpanded ? 'show' : ''}`}>
                                <h6 className='f-16 fw-600 txt-white'>Quick Links</h6>
                                <ul>
                                    {menuItems1.map((item, index) => {
                                        if (item.to) {
                                            return (
                                                <li key={index}><Link className='txt-white-60' to={item.to}>{item.name}</Link></li>
                                            )
                                        }
                                        return (
                                            <li key={index}><Link className='txt-white-60' onClick={handleContactClick}>{item.name}</Link></li>
                                        )
                                    })}
                                </ul>
                            </div>
                            <div className={`col-xl-2 col-md-4 col-9 foot-list2 mb-lg-0 ${isExpanded ? 'show' : ''}`}>
                                <h6 className='f-16 fw-600 txt-white'>Follow Us</h6>
                                <ul>
                                    {menuItems2.map((item, index) => {
                                        return (
                                            <li key={index}><Link className='txt-white-60' to={item.to} target="_blank" rel="noopener noreferrer">{item.name}</Link></li>
                                        )
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className='copyrights-cont'>
                        <div className='row'>
                            <div className='col-lg-13 col-18 cr-lt-cont txt-lg-lt txt-center mb-0'>
                                <p className='f-12 txt-white mb-0'>© {new Date().getFullYear()} ZYX Media. All rights reserved.</p>
                                <ul>
                                    {copyItems.map((item, index) => {
                                        return (
                                            <li key={index}><Link className='f-12 txt-white-60 mb-0'>{item.name}</Link></li>
                                        )
                                    })}
                                </ul>
                            </div>
                            <div className='col-lg-5 col-18 social-icons float-lg-end txt-center mb-0'>
                                <ul>
                                    {socialItems.map((item, index) => {
                                        return (
                                            <li key={index}><Link to={item.to} className={item.class} target="_blank" rel="noopener noreferrer"></Link></li>
                                        )
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer >
    )
}
